import { render } from "./multi-image-display-card.vue?vue&type=template&id=2b181391&scoped=true&ts=true"
import script from "./multi-image-display-card.vue?vue&type=script&lang=ts"
export * from "./multi-image-display-card.vue?vue&type=script&lang=ts"

import "./multi-image-display-card.vue?vue&type=style&index=0&id=2b181391&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b181391"]])

export default __exports__